export default __webpack_public_path__ + "static/media/tsvetan_xl.8e4e432e.jpg";